// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"uj","red":"vj","calloutlink":"wj","headerTopBanner":"xj","bgcolorRed":"yj","headerTopCallout":"zj","searchBanner":"Aj","hideMobile":"Bj"};